import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-upload-req-step-activate',
  templateUrl: './upload-req-step-activate.component.html',
  styleUrls: ['./upload-req-step-activate.component.css']
})
export class UploadReqStepActivateComponent {

  @Input() isActivateRequisitionEnabled: boolean;
  @Input() currentJobStatus;

  @Output() activateRequisitionSwitchChangeCallback = new EventEmitter<boolean>();

  onActivateRequisitionSwitchChange() {
    this.activateRequisitionSwitchChangeCallback.emit(this.isActivateRequisitionEnabled);
  }
}
